// Shared human-label helper for document status enums, in the pattern of
// humanTaskStatus. Use this in any surface that shows document status to a
// member. Never render a raw enum value.

export const DOCUMENT_STATUS_LABEL: Record<string, string> = {
  draft: "Draft",
  pending_review: "Ready to review",
  final: "Final",
  finalized: "Final",
  signed: "Signed",
  archived: "Filed",
};

export function humanDocumentStatus(status: string | null | undefined): string {
  if (!status) return "Draft";
  return DOCUMENT_STATUS_LABEL[status] ?? "Draft";
}
